import { useQuery } from "@tanstack/react-query";
import { GET_ATTENDANCE_CHECK, getAttendanceCheck } from "modules";

export const useAttendanceCheckQuery = ({ studentBatchId, load }) => {
  return useQuery({
    queryKey: [GET_ATTENDANCE_CHECK, studentBatchId],
    queryFn: () =>
      getAttendanceCheck({
        studentBatchId,
      }),
    enabled: load && !!studentBatchId,
  });
};
